var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { html, css } from 'lit';
import { stringDecoder, numberDecoder, customElement, PICBase } from '../Internals';
let PICGallery = class PICGallery extends PICBase {
    constructor() {
        super();
        this.width = 0;
        this.noteKey_ = '';
        this.comp_ = '';
        this.fileLst = [];
    }
    static get styles() {
        const defaultStyle = css `
            .cardcontainer{
                width: fit-content;
                height: auto;
                flex-wrap: wrap;
                display: flex;
                gap: 0.8rem;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    focus() {
    }
    get submitValue() {
        return null;
    }
    validateSubmit() {
        return true;
    }
    connectedCallback() {
        super.connectedCallback();
    }
    render() {
        return html `
            ${this.renderCSS(true)}
            <style>
            </style>
            <slot class="cardcontainer">
            </slot>
        `;
        /*${repeat(this.fileLst!, (item, index) => this.renderFile(item, index))}*/
    }
};
__decorate([
    property({ converter: numberDecoder })
], PICGallery.prototype, "width", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'notekey' })
], PICGallery.prototype, "noteKey_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'comp' })
], PICGallery.prototype, "comp_", void 0);
PICGallery = __decorate([
    customElement('pic-gallery')
], PICGallery);
export { PICGallery };
//# sourceMappingURL=PICGallery.js.map